import { AxiosError, AxiosInstance } from 'axios';
import {
  AgentDto,
  ContactActivityTypes,
  ProspectActivity,
  ProspectDetails,
  ProspectDto
} from 'service/dto/prospect.dto';
import { errorHandler } from 'utils';

class ManageProspectService {
  private baseService: AxiosInstance;

  constructor(baseService: AxiosInstance) {
    this.baseService = baseService;
  }

  getProspects = async (): Promise<ProspectDto> => {
    try {
      const response = await this.baseService.get(
        `/prospect/find-all-prospect`
      );
      return response?.data;
    } catch (error: any) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  getProspectDetails = async (prospectId: string): Promise<ProspectDetails> => {
    try {
      const response = await this.baseService.get(
        `/prospect/prospect-details/${prospectId}`
      );
      return response?.data;
    } catch (error: any) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  getProspectActivity = async (
    prospectId: string
  ): Promise<ProspectActivity> => {
    try {
      const response = await this.baseService.get(
        `/prospect/prospect-activities/${prospectId}`
      );
      return response?.data;
    } catch (error: any) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  assignAgentToProspect = async (
    prospectId: string,
    agentId: number
  ): Promise<any> => {
    try {
      const response = await this.baseService.patch(
        `/prospect/assign-agent/${prospectId}/${agentId}`,
        {},
        {
          timeout: 40000
        }
      );
      return response?.data;
    } catch (error: any) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  getAgentList = async (): Promise<AgentDto> => {
    try {
      const response = await this.baseService.get(`/prospect/agent-list`);
      return response?.data;
    } catch (error: any) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  createActivity = async (payload: any): Promise<any> => {
    try {
      const response = await this.baseService.post(
        `/prospect/create-activity`,
        payload
      );
      return response?.data;
    } catch (error: any) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  getAgentActivityType = async (): Promise<ContactActivityTypes> => {
    try {
      const response = await this.baseService.get(
        `/prospect/agent-activity-type`
      );
      return response?.data;
    } catch (error: any) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  getAgentContactType = async (): Promise<ContactActivityTypes> => {
    try {
      const response = await this.baseService.get(
        `/prospect/agent-contact-type`
      );
      return response?.data;
    } catch (error: any) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };
}

export default ManageProspectService;
